// extracted by mini-css-extract-plugin
module.exports = {"resizeHandleContainer":"Resize_resizeHandleContainer__2euCb","resizeHandle":"Resize_resizeHandle__2eTUr"};